import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

// formik components
import { Formik, Form, Field, FieldArray } from "formik";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Box, CircularProgress, Dialog, IconButton } from "@mui/material";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { addNewPlaceApi, updatePlaceApi } from "api/places";

import { v4 as uuidv4 } from "uuid";
import { getNumberOfAvailableTickets } from "api/tickets";
import { useParams } from "react-router-dom";

function EventSelectedSieges({
  openEventSelectedSiege,
  closeEventSelectedSiege,
  refreshData,
  isEdite,
  openModalItemData,
  newSiegeData,
}) {
  const [isOnlineChecked, setIsOnlineChecked] = useState(false);
  const [sumOfAvailableTicket, setSumOfAvailableTicket] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const { eventID } = useParams();

  // const validationSchema = Yup.object().shape({
  //   eventPlace: Yup.string().required("Saisser le nom de nouvelle lieu"),
  //   eventLocation: Yup.string().required("Saisser la localisation"),
  // });

  const validationSchema = Yup.object().shape({
    eventSiege: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required("Saisir le nom de lieu"),
          price: Yup.number().required("Saisir le prix de siège"),
          numberOfPlaces: Yup.number().required("Saisir le nombre limite de places"),
          isSoldOut: Yup.boolean().required(),
        })
      )
      .required("Vous devez ajouter au moins un lieu"),
  });

  useEffect(() => {
    getInitialValue();
  }, [openEventSelectedSiege]);

  const getInitialValue = async () => {
    try {
      const numberOfAvailableTickets = await getNumberOfAvailableTickets(eventID);
      setSumOfAvailableTicket(numberOfAvailableTickets);

      // console.log(numberOfAvailableTickets.groupedData)
      // console.log(numberOfAvailableTickets.length)
      // console.log("openModalItemData =>", openModalItemData)

      // const sumOfUpdatedTickets = openModalItemData.reduce((sum, item) => sum + item.price, 0)

      if (isEdite) {
        setIsOnlineChecked(openModalItemData?.isOnline);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddNewEventSiege = async (value) => {
    try {
      const sumOfAvailableTicketsByCategory = sumOfAvailableTicket.groupedData;
      // const sumOfUpdatedNbrOfTicket = value.eventSiege.reduce((acc, item) => acc + item.numberOfPlaces, 0)

      // Get the length of each array
      const availableTicketslengths = Object.keys(sumOfAvailableTicketsByCategory).reduce(
        (acc, key) => {
          acc[key] = sumOfAvailableTicketsByCategory[key].length;
          return acc;
        },
        {}
      );

      const errors = [];

      value.eventSiege.map((el) => {
        if (availableTicketslengths[el.id] > el.numberOfPlaces) {
          // alert(`Vous ne pouvez pas ajouter plus de ${el.numberOfPlaces}`)

          errors.push(`Vous ne pouvez pas ajouter ${el.numberOfPlaces} pour le siege ${el.name}`);
        }
      });

      if (errors.length > 0) {
        return Swal.fire({
          title: "Error!",
          text: errors[0],
          icon: "error",
          confirmButtonText: "OK",
        });
      }

      // if(sumOfAvailableTicket.length > sumOfUpdatedNbrOfTicket) {
      // return Swal.fire({
      //   title: "Error!",
      //   text: "Vous ne pouvez pas ajouter plus de siège que le nombre de billet disponible",
      //   icon: "error",
      //   confirmButtonText: "OK"
      // })
      // }

      // const formValues = {
      //   name: value.eventPlace,
      //   location: value.eventLocation,
      //   isOnline: isOnlineChecked
      // }

      // await addNewPlaceApi(formValues)
      Swal.fire({
        title: "Ajoutée",
        text: "",
        icon: "success",
      });

      newSiegeData(value);

      // refreshData()
      closeEventSelectedSiege();
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdateEventPlace = async (value) => {
    try {
      // const formValues = {
      //   name: value.eventPlace,
      //   location: value.eventLocation,
      //   isOnline: isOnlineChecked
      // }
      // await updatePlaceApi(formValues, openModalItemData._id)
      // Swal.fire({
      //   title: "Modifiée",
      //   text: "",
      //   icon: "success"
      // });
      // refreshData()
      // closeEventSelectedSiege();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Dialog
        open={openEventSelectedSiege}
        onClose={closeEventSelectedSiege}
        fullWidth
        maxWidth="lg"
      >
        <MDBox>
          <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <Grid item xs={12}>
              <Formik
                initialValues={{
                  eventSiege: openModalItemData ? openModalItemData : [],
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  isEdite ? handleUpdateEventPlace(values) : handleAddNewEventSiege(values);
                }}
              >
                {({ values, setFieldValue }) => (
                  <Form autoComplete="off">
                    <Card sx={{ height: "100%" }}>
                      <MDBox p={3}>
                        <MDBox>
                          <FieldArray name="eventSiege">
                            {({ push, remove }) => (
                              <>
                                {values.eventSiege.map((place, index) => (
                                  <Grid container spacing={1} key={index} alignItems="center">
                                    <Grid item xs={12} sm={3} mb={1.2}>
                                      <Field name={`eventSiege[${index}].name`}>
                                        {({ field, meta }) => (
                                          <>
                                            <MDInput
                                              {...field}
                                              label="Siège"
                                              size="large"
                                              fullWidth
                                              error={meta.error}
                                              success={!meta.error && meta.touched}
                                            />
                                            {meta.touched && meta.error && (
                                              <MDTypography
                                                component="div"
                                                variant="caption"
                                                color="error"
                                                fontWeight="regular"
                                              >
                                                {meta.error}
                                              </MDTypography>
                                            )}
                                          </>
                                        )}
                                      </Field>
                                    </Grid>

                                    <Grid item xs={12} sm={3} mb={1.2}>
                                      <Field name={`eventSiege[${index}].price`}>
                                        {({ field, meta }) => (
                                          <>
                                            <MDInput
                                              {...field}
                                              type="number"
                                              label="Prix"
                                              size="large"
                                              fullWidth
                                              error={meta.error}
                                              success={!meta.error && meta.touched}
                                            />
                                            {meta.touched && meta.error && (
                                              <MDTypography
                                                component="div"
                                                variant="caption"
                                                color="error"
                                                fontWeight="regular"
                                              >
                                                {meta.error}
                                              </MDTypography>
                                            )}
                                          </>
                                        )}
                                      </Field>
                                    </Grid>

                                    <Grid item xs={12} sm={3} mb={1.2}>
                                      <Field name={`eventSiege[${index}].numberOfPlaces`}>
                                        {({ field, meta }) => (
                                          <>
                                            <MDInput
                                              {...field}
                                              type="number"
                                              label="Nombre des places"
                                              size="large"
                                              fullWidth
                                              error={meta.error}
                                              success={!meta.error && meta.touched}
                                            />
                                            {meta.touched && meta.error && (
                                              <MDTypography
                                                component="div"
                                                variant="caption"
                                                color="error"
                                                fontWeight="regular"
                                              >
                                                {meta.error}
                                              </MDTypography>
                                            )}
                                          </>
                                        )}
                                      </Field>
                                    </Grid>

                                    <Grid item xs={12} sm={2} mb={1.2}>
                                      <Field name={`eventSiege[${index}].isSoldOut`}>
                                        {({ field }) => (
                                          <MDBox display="flex" alignItems="center">
                                            <MDTypography
                                              variant="body2"
                                              fontWeight="regular"
                                              mr={2}
                                            >
                                              Soldout
                                            </MDTypography>
                                            <Switch
                                              {...field}
                                              checked={field.value}
                                              onChange={(event) => field.onChange(event)}
                                              color="primary"
                                            />
                                          </MDBox>
                                        )}
                                      </Field>
                                    </Grid>

                                    {/* <Grid item xs={12} sm={1}>
                                      <IconButton onClick={() => remove(index)} color="error">
                                        <DeleteIcon fontSize="30px" />
                                      </IconButton>
                                    </Grid> */}
                                  </Grid>
                                ))}
                                <MDButton
                                  type="button"
                                  onClick={() =>
                                    push({
                                      name: "",
                                      price: null,
                                      numberOfPlaces: null,
                                      id: uuidv4(),
                                      isSoldOut: false,
                                    })
                                  }
                                  variant="text"
                                  color="success"
                                  startIcon={<AddIcon />}
                                >
                                  Ajouter un siège
                                </MDButton>
                              </>
                            )}
                          </FieldArray>
                          {isLoaded ? (
                            <Box sx={{ display: "flex" }}>
                              <CircularProgress />
                            </Box>
                          ) : (
                            <MDButton type="submit" variant="gradient" color="dark">
                              Modifier
                            </MDButton>
                          )}
                        </MDBox>
                      </MDBox>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </Dialog>
    </div>
  );
}

EventSelectedSieges.propTypes = {
  openEventSelectedSiege: PropTypes.bool.isRequired,
  closeEventSelectedSiege: PropTypes.func.isRequired,
};

export default EventSelectedSieges;
